import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  template: ''
})
export class BaseControlValueAccessor implements ControlValueAccessor {

  @Input()
  name: string | any;

  @Input()
  label: string;

  @Input()
  placeholder: string;

  @Input()
  isEditable: boolean;

  @Input()
  beLight: boolean;

  //this is user for tooltip delay
  @Input()
  delay: number = 2000;
  @Input()
  nestedError: boolean = false;

  @Input()
  showSelectAll: boolean = false;

  @Input()
  showCustom: boolean = false;

  //used in superlocations
  dataStatement: string;

  _errors: string[];
  @Input()
  get errors() {
    return this._errors;
  }

  set errors(val) {
    if (val == null) {
      this._errors = [];
    } else {
      this._errors = val;
      this.errorsChange.emit(val);
    }
  }

  @Output()
  errorsChange = new EventEmitter<any>();

  @Input()
  tooltipIcon: boolean = false;

  @Input()
  tooltipName: string;

  @Input()
  disabled: boolean = false;

  isInit = true;

  _data;

  // defaultFontSize:string='medium';

  @Input()
  get data() { // @TODO Check why it is breaking on setting data.
    return this._data
  }

  set data(val) {
    if (this.showSelectAll) {
      if (this._data != null) {
        const uniqueIds = {};
        const filteredData = val.filter(item => {
          if (!uniqueIds[item.id]) {
            uniqueIds[item.id] = true;
            return true;
          }
          return false;
        });
        this._data = filteredData;
      } else {
        this._data = val;
      }
    } else
      this._data = val;
    this.errors = [];
    if (!this.isInit) {
      this.validate(val);
      this.isInit = false;
    }
    this.onChange(val);
  }

  isDisabled = false;

  onChange = (_: any) => {
  }
  onTouch = (_: any) => {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled
  }

  writeValue(obj: any): void {
    this.data = obj;
  }

  applyUrlTransforms(url, transforms) {
    for (const [key, value] of Object.entries(transforms)) {
      url = url.replace(`::${key}::`, encodeURIComponent(value.toString()))
    }

    return url;
  }

  roundoff_decimal(num, places = 2) {
    let multiplier = Math.pow(10, places);
    return Math.round(multiplier * num) / multiplier;
  }

  validate(val) {
    console.error(`validate function is not implemented in ${this.constructor.name}`)
  }
}
